import { useContext, useRef, useState } from 'react'

import { OTPForm } from '@paysense-india-services/auth-vista'

import { AUTH_FORM_VARIANT } from '@/constants/layout'

import { AuthContext } from '@/contexts/AuthContext'
import { useProductConfig } from '@/contexts/ProductConfigContext'

import useOtpPrerequisiteGuard from '@/hooks/useOtpPrerequisiteGuard'

import { parseErrorMessage } from '@/utils/errorParser'
import { OTP_PREREQUISITE_KIND } from '@/utils/otpPrerequisites'

import AuthFormShell from '@/components/layouts/AuthFormShell'

import {
  getProductRequest,
  normalizeProductResponse,
  PRODUCT_OPERATIONS
} from '@/config/productApi'
import {
  getStoredMobile,
  getStoredOtpId,
  setStoredMobile,
  setStoredOtpId,
  setStoredPendingPhoneOtp
} from '@/config/sourceStorage'

const PhoneOtpPage = () => {
  const otpRef = useRef()
  const { config } = useProductConfig()
  const { loginUser } = useContext(AuthContext)
  const [error, setError] = useState(null)
  const mobile = getStoredMobile()

  useOtpPrerequisiteGuard(OTP_PREREQUISITE_KIND.PHONE)

  const verifyLoginRequest = getProductRequest(config, PRODUCT_OPERATIONS.VERIFY_LOGIN, {})
  const sendOtpRequest = getProductRequest(config, PRODUCT_OPERATIONS.SEND_OTP, {})

  const onVerifyOtpSuccess = response => {
    const result = normalizeProductResponse(config, PRODUCT_OPERATIONS.VERIFY_LOGIN, response)
    globalThis.showSnackbar?.('OTP Verified Successfully', { type: 'success' })
    setStoredMobile(null)
    setStoredOtpId(null)
    setStoredPendingPhoneOtp(null)
    loginUser(result.muid)
  }

  const getRequestBody = () => {
    const req = getProductRequest(config, PRODUCT_OPERATIONS.VERIFY_LOGIN, {
      code: otpRef.current,
      phone: mobile,
      otpId: getStoredOtpId()
    })
    return {
      data: req.data,
      headers: req.headers,
      credentials: req.credentials
    }
  }

  const getResendOTPRequestBody = async () => {
    const req = getProductRequest(config, PRODUCT_OPERATIONS.SEND_OTP, { phone: mobile })
    return { data: req.data, headers: req.headers }
  }

  return (
    <AuthFormShell headerVariant="back" hideHeaderOnDesktop variant={AUTH_FORM_VARIANT.FLUID}>
      <OTPForm
        api={verifyLoginRequest.url}
        config={{
          title: 'Verify Phone Number',
          subTitle: `We have sent an OTP to +91 ${mobile || ''}`
        }}
        error={error ?? { message: '' }}
        getRequestBody={getRequestBody}
        getResendOTPRequestBody={getResendOTPRequestBody}
        onError={err =>
          setError(new Error(parseErrorMessage(err) || err?.message || 'Invalid OTP'))
        }
        onOTPChange={otp => {
          setError(null)
          otpRef.current = otp
        }}
        onResendOTPError={err =>
          globalThis.showSnackbar?.(
            parseErrorMessage(err) || err?.message || 'Something went wrong',
            { type: 'error' }
          )
        }
        onResendOTPSuccess={response => {
          setError(null)
          const result = normalizeProductResponse(config, PRODUCT_OPERATIONS.SEND_OTP, response)
          if (result.otpId) setStoredOtpId(result.otpId)
          globalThis.showSnackbar?.('OTP Sent Successfully', { type: 'success' })
        }}
        onSuccess={onVerifyOtpSuccess}
        resendApi={sendOtpRequest.url}
        resendTimer={60}
      />
    </AuthFormShell>
  )
}

export default PhoneOtpPage
